import { render, staticRenderFns } from "./Duty.vue?vue&type=template&id=fe36b5a8&scoped=true&"
import script from "./Duty.vue?vue&type=script&lang=js&"
export * from "./Duty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe36b5a8",
  null
  
)

export default component.exports